import { api } from "@/lib/api";
import { getUTM, getQRSource } from "@/lib/utm";
import { logger } from "@/lib/logger";

const sentOncePerSession = new Set();

/**
 * Send an analytics event to backend.
 * Modular: can later plug into PostHog/Plausible by changing this file only.
 */
export async function track(event_name, properties = {}) {
  const page = typeof window !== "undefined" ? window.location.pathname : "/";
  const utm = getUTM();
  const qr = getQRSource();
  const payload = {
    event_name,
    page,
    properties,
    source: qr.source || null,
    utm_source: utm.utm_source,
    utm_medium: utm.utm_medium,
    utm_campaign: utm.utm_campaign,
    restaurant_id: qr.restaurant_id,
    qr_source: qr.qr_source,
  };
  try {
    await api.post("/analytics/events", payload);
  } catch (err) {
    // Never break UX on tracking failure — log for diagnostics
    logger.warn("[analytics] event failed:", event_name, err);
  }
}

/** Fire an event only once per session for the given key. */
export async function trackOnce(key, event_name, properties = {}) {
  if (sentOncePerSession.has(key)) return;
  sentOncePerSession.add(key);
  await track(event_name, properties);
}
